export interface SystemStatus {
    database: boolean;
    outstandingReports: boolean;
    outstandingSFSyncs: boolean;
    pismo: boolean;
    illion: boolean;
    redbook: boolean;
    hubspot: boolean;
    userLogin: boolean;
    docusign: boolean;
    verimoto: boolean;
    ilink: boolean;
    salesforce: boolean;
    googleApi: boolean;
    googleDocumentAi: boolean;
    abr: boolean;
    twilio: boolean;
    equifax: boolean;
    azureStorage: boolean;
    digitalId: boolean;
    bpay: boolean;
    creditorWatch: boolean;
    basiq: boolean;
    sendGrid: boolean;
    netsuite: boolean;
    pythonApi: boolean;
}

export type ConnectionDetails = {
    [key: string]: {
        [value: string]:string | number | boolean | object | undefined;
        type: 'text' | 'password' | 'number' | 'date' | 'email' | 'boolean' | 'array-object-grouped' | 'array';
    }
};


export interface ConnectionDetail {
    value: string | number | boolean | object;
    type: 'text' | 'password' | 'number' | 'date' | 'email' | 'boolean' | 'array-object-grouped' | 'array';
  }
  
export interface EncryptedDetails {
    [key: string]: {
      value: string | null | object;
      type: ConnectionDetail['type'];
    };
  }
  

export interface ServiceStatus {
    status: boolean;
    message: string; // leave error message here
    details?: ConnectionDetails;
}


export type SystemStatusRespons1 = {
    [key: string]: {
        [value: string]: ServiceStatus;
    };
};
export type SystemStatusResponse = {
    [key: string]: ServiceStatus | string;
};

export interface SystemStatusInput {
    responseTime?: number;
    performance?: boolean;
    database?: boolean;
    pismo?: boolean;
    illion?: boolean;
    redbook?: boolean;
    hubspot?: boolean;
    salesforce?: boolean;
    docusign?: boolean;
    verimoto?: boolean;
    ilink?: boolean;
    portal?: boolean;
    all?: boolean;
    googleApi?: boolean;
    googleDocumentAi?: boolean;
    abr?: boolean;
    twilio?: boolean;
    equifax?: boolean;
    azureStorage?: boolean;
    bpay?: boolean;
    creditorWatch?: boolean;
    basiq?: boolean;
    sendGrid?: boolean;
    netsuite?: boolean;
    pythonApi?: boolean;
    cronJob?: boolean;
}
// Type for encrypted environment values
export type EncryptedValue = {
    iv: string;
    encryptedData: string;
  };
  
